import { Injectable } from '@angular/core';
import { AnalysisFilterKeys } from './key-resolver.service';
import { GeneralService } from './general.service';
import { KeyNameDto } from '@ex/core/common';

@Injectable({
  providedIn: "root"
})
export class SurveyCriteriaService {

  constructor(private generalService: GeneralService) { }

  process(criterias: { key: string, name: KeyNameDto[], isCustom: boolean, isEntity: boolean }[], addDisplayCriteria: boolean = false) {
    const criteriaList = [];
    for (let criteria of criterias) {

      switch (criteria.key) {

        case AnalysisFilterKeys.DateOfBirth || addDisplayCriteria:

          const ageGroups = this.generalService.ageGroups_new;
          const generation = this.generalService.generations_new

          criteriaList.push({
            key: AnalysisFilterKeys.AgeGroups,
            name: this.generalService.fixedGroupingOptions.find(group => group.key == AnalysisFilterKeys.AgeGroups).name,
            options: ageGroups
          });
          criteriaList.push({
            key: AnalysisFilterKeys.Generation,
            name: this.generalService.fixedGroupingOptions.find(group => group.key == AnalysisFilterKeys.Generation).name,
            options: generation
          });
          break;

        case AnalysisFilterKeys.DateOfJoining || addDisplayCriteria:

          const tenureGroups = this.generalService.tenureGroups_new;

          criteriaList.push({
            key: AnalysisFilterKeys.TenureGroups,
            name: this.generalService.fixedGroupingOptions.find(group => group.key == AnalysisFilterKeys.TenureGroups).name,
            options: tenureGroups
          });
          break;

        case AnalysisFilterKeys.DirectManagerId:
          break;

        default:
          criteriaList.push(criteria);
      }

    }

    return criteriaList;
  }

}